"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ESFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_70)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_70`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V6.4H-6V0ZM-6 17.6H30V24H-6V17.6Z",
					fill: "#D03433"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 6.3999H30V17.5999H-6V6.3999Z",
					fill: "#FBCA46"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.47998 11.2H8.07998V12H6.47998V11.2Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.52 13.5999C5.52 14.0799 6 14.3999 6.48 14.3999C6.96 14.3999 7.44 14.0799 7.44 13.5999L7.6 11.1999H5.36L5.52 13.5999ZM4.56 11.1999C4.56 10.7199 4.88 10.3999 5.2 10.3999H7.6C8.08 10.3999 8.4 10.7199 8.4 11.0399V11.1999L8.24 13.5999C8.08 14.5599 7.44 15.1999 6.48 15.1999C5.52 15.1999 4.88 14.5599 4.72 13.5999L4.56 11.1999Z",
					fill: "#A41517"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.87998 12H8.07998V12.8H7.27998L6.47998 14.4L5.67998 12.8H4.87998V12ZM2.47998 9.6H4.07998V15.2H2.47998V9.6ZM8.87998 9.6H10.48V15.2H8.87998V9.6ZM4.87998 8.8C4.87998 8.32 5.19998 8 5.67998 8H7.27998C7.75998 8 8.07998 8.32 8.07998 8.8V9.12C8.07998 9.44 7.91998 9.6 7.59998 9.6H5.19998C5.03998 9.6 4.87998 9.44 4.87998 9.28V8.8Z",
					fill: "#A41517"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_70`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ESFlag };
